<template>
  <div class="page-sign-in">
    <div class="page-sign-in__container">
      <template v-if="!user">
        <p class="page-sign-in__header">Регистрация нового пользователя</p>
        <el-input
          placeholder="Login"
          v-model="login"
          class="page-sign-in__input"
          size="medium"
        ></el-input>
        <el-input
          placeholder="Password"
          v-model="password"
          class="page-sign-in__input"
          size="medium"
          type="password"
        ></el-input>
        <el-input
          placeholder="E-Mail"
          v-model="email"
          class="page-sign-in__input"
          size="medium"
          type="email"
        ></el-input>
        <el-button size="medium" type="primary" round @click="submit">Submit</el-button>
      </template>



      <template v-if="!!user">
        <p>Подтверждение регистрации</p>
        <el-input
          placeholder="Code"
          v-model="code"
          class="page-sign-in__input"
          size="medium"
        ></el-input>
        <el-button size="medium" type="primary" round @click="confirm">Submit</el-button>
      </template>
    </div>
  </div>
</template>

<script>
/**
 * Page: Страница регистрации администратора
 *
 * @version 1.0.0
 */


import { Auth } from 'aws-amplify';
import { mapMutaions } from 'vuex';

export default {
  name: 'page-sign-in',

  data() {
    return {
      login: '',
      password: '',
      email: '',
      code: '',
      user: null,
    };
  },

  methods: {
    /**
     * Первый этап регистраци нового пользователя (регистрация)
     */
    submit() {
      Auth.signUp({
        username: this.login,
        password: this.password,
        attributes: {
          email: this.email,
        },
        validationData: [],
        })
        .then(data => {
          this.user = data.user;
          console.log(data);
        })
        .catch(err => {
          console.log(err);
          this.$notify({
            title: 'Register User Error',
            message: err.message,
            duration: 0
          });
        });
    },


    /**
     * Второй этап регистрации пользователя (подтверждение)
     */
    confirm() {
      // After retrieveing the confirmation code from the user
      Auth.confirmSignUp(this.login, this.code, {
        // Optional. Force user confirmation irrespective of existing alias. By default set to True.
        forceAliasCreation: true,
      }).then(() => this.$router.push('points'))
        .catch(err => {
          this.$notify({
            title: 'Confirm User Error',
            message: err.message,
            duration: 0
          });
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.page-sign-in {
  position: relative;
  width: 100vw;
  height: 100vh;

  &__header {
    text-align: center;
  }

  &__container {
    width: 240px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  &__input {
    margin-bottom: 10px;
  }
}
</style>

